/*
  voltage: free gift automation for the tiered cart.

  Defines two custom elements used by voltage--free-shipping-bar--tiered-free-gifts.liquid:
    <free-gift-adds>     - auto-adds qualifying gifts when a cart threshold is met
    <free-gift-removals> - removes gifts when the cart drops below their threshold

  Extracted from assets/theme.js on 2026-07-15. It previously lived inside that vendor
  file, where a Stretch update would have silently dropped it and broken free gifts with
  no error. Nothing here imports from "theme" or "vendor" - it is self-contained - so it
  loads as a standalone module from layout/theme.liquid.

  Do not move this back into theme.js.
*/

if (!window.customElements.get('free-gift-removals')) {

  class FreeGiftRemovals extends HTMLElement {

    constructor() {
      super();
      this.processed = false;
    }

    connectedCallback() {
      this.cartDrawer = document.querySelector('cart-drawer');
      this.init();
    }

    init() {
      if (this.removals && !this.processed) {
        this.processed = true;
        this.removeGifts();
      }
    }

    async removeGifts() {

      try {

        const updates = {};

        for (let i = 0; i < this.removals.length; i++) {
          const removal = this.removals[i];
          updates[removal.dataset.key] = 0;
        }

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

        this.fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: updates,
            sections: sectionsToBundle.join(",")
          })
        };

        const response = await fetch(`${Shopify.routes.root}cart/update.js`, this.fetchRequestOpts);

        if (this.cartDrawer) {

          const cartContent = await response.json();

          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent
            }
          }));

        }
        else {
          location.reload();
        }

      } catch (error) {

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

      }

    }

    get removals() {
      return this.querySelectorAll('free-gift-remove');
    }

  }

  window.customElements.define("free-gift-removals", FreeGiftRemovals);

}


if (!window.customElements.get('free-gift-adds')) {

  class FreeGiftAdds extends HTMLElement {

    constructor() {
      super();
      this.processed = false;
    }

    connectedCallback() {
      this.cartDrawer = document.querySelector('cart-drawer');
      this.init();
    }

    init() {
      if (this.adds && !this.processed) {
        this.processed = true;
        this.addGifts();
      }
    }

    async addGifts() {

      try {

        let postData = {
          'items': []
        };

        for (let i = 0; i < this.adds.length; i++) {

          const add = this.adds[i];
          const quantity = 1;

          let item = {};

          item.id = Number(add.dataset.variantId);
          item.quantity = quantity;

          item.properties = {};
          item.properties["Free Gift"] = add.dataset.giftTitle;
          item.properties["_Free Gift Number"] = add.dataset.giftIndex;
          item.properties["_Free Gift ID"] = add.dataset.giftId;

          postData.items.push(item)

        }

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

        postData.sections = sectionsToBundle.join(",");

        let fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(postData)
        };

        const response = await fetch(`${Shopify.routes.root}cart/add.js`, fetchRequestOpts);

        if (response.ok) {

          const cartContent = await response.json();

          if (this.cartDrawer) {

            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: cartContent
              }
            }));

          }
          else {
            location.reload();
          }

        }
        else {

          const responseJson = await response.json();

          document.dispatchEvent(new CustomEvent("toast:show", {
            detail: {
              message: responseJson["message"],
              tone: "error"
            }
          }));

        }

      } catch (error) {

        console.log(error);

        /*
        document.dispatchEvent(new CustomEvent("toast:show", {
          bubbles: true,
          detail: {
            message: error.message,
            tone: "error"
          }
        }));
        */

      }

    }

    get adds() {
      return this.querySelectorAll('free-gift-add');
    }

  }

  window.customElements.define("free-gift-adds", FreeGiftAdds);

}
